<div *ngIf="showMobileTabs" class="einstallen-mobile-layout">
    <kiene-einstallen-mobile-review
        *ngIf="showMobileReviewStep"
        [gruppe]="gruppe"
        (back)="closeMobileReview()"
        (completed)="onMobileReviewCompleted()"
    ></kiene-einstallen-mobile-review>

    <div
        class="einstallen-mobile-scan-view"
        [class.einstallen-mobile-scan-view--hidden]="showMobileReviewStep"
    >
        <kiene-mobile-page-header [ueberschrift]="'Einstallen'">
            <button
                mobileHeaderActions
                type="button"
                mat-flat-button
                color="accent"
                class="einstallen-mobile-liste-abschliessen"
                data-cy="einstallen-mobile-liste-abschliessen"
                [disabled]="isMobileListeAbschliessenDisabled()"
                (click)="openMobileReview()"
            >
                Liste abschließen
            </button>
        </kiene-mobile-page-header>

        <h4 class="einstallen-gruppe-title">Gruppe: {{ gruppe?.bezeichnung }}</h4>

        <mat-tab-group
            class="einstallen-tabs"
            (selectedTabChange)="tabChanged($event)"
            headerPosition="above"
            mat-stretch-tabs
        >
            <mat-tab>
                <ng-template data-cy="einstallen-tab-pass-ohrmarke" matTabLabel>
                    <mat-icon>barcode_reader</mat-icon>
                </ng-template>
                <div class="einstallen-tab-content">
                    <kiene-einstallen-tiere-hinzufuegen
                        [gruppe]="gruppe"
                        [showPassReiter]="showPassReiter"
                        [forceNewEinstallTierliste]="forceNewEinstallTierliste"
                        [hideMobileHeader]="true"
                    >
                    </kiene-einstallen-tiere-hinzufuegen>
                </div>
            </mat-tab>

            <mat-tab [disabled]="!gruppe" data-cy="einstallen-tab-number-pad">
                <ng-template matTabLabel>
                    <mat-icon>dialpad</mat-icon>
                </ng-template>
                <div class="einstallen-tab-content">
                    <kiene-einstallen-number-pad
                        [isVisible]="currentTabIndex === 1"
                        [hidePageHeader]="true"
                    ></kiene-einstallen-number-pad>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>

<div *ngIf="!showMobileTabs" class="einstallen-overview" data-cy="einstallen-tab-pass-ohrmarke">
    <div class="einstallen-tab-content">
        <kiene-einstallen-tiere-hinzufuegen
            [gruppe]="gruppe"
            [showPassReiter]="showPassReiter"
            [forceNewEinstallTierliste]="forceNewEinstallTierliste"
        >
        </kiene-einstallen-tiere-hinzufuegen>
    </div>
</div>
